export const rfqConfig = {
    fields : [{
        type: 'textField',
        title: 'Title',
        key: 'title',
        editable: true
    },{
        type: 'date',
        title: 'Preview Date',
        key: 'previewDate'
    },{
        type: 'textField',
        title: 'Open Date',
        key: 'openDate'
    },{
        type: 'date',
        title: 'Close Date',
        key: 'closingDate',
        editable: true
    },{
        type: 'textField',
        title: 'Award Date',
        key: 'awardDate'
    },{
        type: 'textArea',
        title: 'Note',
        key: 'note',
        editable: true
    },{
        type: 'textField',
        title: 'Buyer - Company',
        key: 'company'
    },{
        type: 'textField',
        title: 'Buyer - Name',
        key: 'buyer'
    },{
        type: 'textArea',
        title: 'Buyer - Location',
        key: 'location',
        editable: true
    },{
        type: 'textField',
        title: 'Buyer - Phone',
        key: 'phone',
        editable: true
    },{
        type: 'textField',
        title: 'Buyer - Fax',
        key: 'fax',
        editable: true
    },{
        type: 'textField',
        title: 'Buyer - Email',
        key: 'email',
        editable: true
    },{
        type: 'textArea',
        title: 'Buyer - Shipping Address',
        key: 'shippingAddress',
        editable: true
    },{
        type: 'textArea',
        title: 'Buyer - Billing Address',
        key: 'billingAddress',
        editable: true
    },{
        type: 'textField',
        title: 'Payment Terms',
        key: 'paymentTerms',
        editable: true
    },{
        type: 'table',
        title: 'Currencies',
        key: 'currencies',
        editable: true,
        columns: [{
            title: 'Currency',
            key: 'currency',
            dataIndex: 'currency',
            editable: true
        },{
            title: 'Currency Description',
            key: 'description',
            dataIndex: 'description',
            editable: true
        },{
            title: 'Price Percision',
            key: 'pricePercision',
            dataIndex: 'pricePercision',
            editable: true
        },{
            title: 'Exchange Rate',
            key: 'exchangeRate',
            dataIndex: 'exchangeRate',
            editable: true
        }]
    },{
        type: 'table',
        title: 'Required Medicines',
        key: 'medicinesRequired',
        editable: true,
        columns: [{
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
            editable: true
        },{
            title: 'Strength',
            key: 'strength',
            dataIndex: 'strength',
            editable: true
        },{
            title: 'Item Rev',
            key: 'itemRev',
            dataIndex: 'itemRev',
            editable: true
        },{
            title: 'Target Quantity',
            key: 'targetQuantity',
            dataIndex: 'targetQuantity',
            editable: true
        },{
            title: 'Unit',
            key: 'unit',
            dataIndex: 'unit'
        }]
    }]
}